import './styles/index.css'
import './styles/profile.css'

import {
  Button,
  Collapse,
  Divider,
  Modal,
  notification,
  Pagination,
  Spin,
  Switch,
  Table,
  Tabs,
  Tag,
  Select
} from 'antd'
import React, { useEffect, useState } from 'react'
import { Tooltip } from 'antd'

import { InfoCircleOutlined, LoadingOutlined } from '@ant-design/icons'
import Slider from 'react-slick'

import TablerCash from '../../assets/images/icons/tabler_cash.png'
import NumberFormat from 'react-number-format'
import {
  _fetch_user_wallet_data,
  _get_user_wallet_account,
  _get_profile,
  _get_pending_orders,
  _get_delivery_fee_stats
} from '../../common/axios_services'
import { useSelector } from 'react-redux'
import AddBikerModal from '../../components/restaurant_delivery/AddBikerModal'
import OrderAcceptanceModal from '../../components/delivery/OrderAcceptanceModal'
import useRestaurantDelivery from './hooks/useRestaurantDelivery'

import { useNavigate } from 'react-router-dom'
import FooterDisplay from '../../components/Restaurant/Footer'

let settings = {
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 1.5,
  slidesToScroll: 1,
  initialSlide: 0,
  swipeToSlide: true,
  draggable: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1.5,
        slidesToScroll: 1,
        infinite: true,
        dots: false,
        centerMode: true,
        focusOnSelect: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1.5,
        slidesToScroll: 1,
        initialSlide: 1,
        centerMode: true,
        focusOnSelect: true
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        focusOnSelect: true
      }
    }
  ]
}

const RestaurantDelivery = () => {
  const params = new URLSearchParams(window?.location?.search)
  const profileData = useSelector(state => state.userProfile.dataFetched)
  const [accountDetails, setAccountDetails] = useState(false)
  const [modalVisible, setModalVisible] = useState(false)
  const [modalContent, setModalContent] = useState({ title: '', desc: '' })
  const [walletData, setWalletData] = useState({})
  const [currency] = useState('NGN')
  const [enabled, setEnabled] = useState(false)
  const [isAddBikerModalVisible, setIsAddBikerModalVisible] = useState(false)
  const [deliveryFeeStats, setDeliveryFeeStats] = useState({
    deliveryFeeTillDate: 0,
    deliveryFeeToday: 0,
    deliveryFeeThisMonth: 0
  })

  const [isOrderAcceptanceModalVisible, setIsOrderAcceptanceModalVisible] =
    useState(false)
  const [selectedOrder, setSelectedOrder] = useState(null)

  const [bikerListPage, setBikerListPage] = useState(1)
  const [bikerListPageSize, setBikerListPageSize] = useState(10)
  const [todayDeliveryPage, setTodayDeliveryPage] = useState(1)
  const [todayDeliveryPageSize, setTodayDeliveryPageSize] = useState(10)
  const [previousDeliveryPage, setPreviousDeliveryPage] = useState(1)
  const [previousDeliveryPageSize, setPreviousDeliveryPageSize] = useState(10)

  const navigate = useNavigate()
  const userData = useSelector(state => state.userProfile.dataFetched)
  const restaurantUserId = userData?.restaurantId

  const openNotificationWithIcon = (type, title, message) => {
    notification[type]({
      message: title,
      description: message,
      placement: 'bottom-right'
    })
  }

  const {
    bikerList,
    todayDeliveries,
    previousDeliveries,
    totalBikers,
    totalTodayDeliveries,
    totalPreviousDeliveries,
    spinnerLoading,
    fetchBikerListData
  } = useRestaurantDelivery(restaurantUserId, openNotificationWithIcon)

  const handleDeliveryChange = checked => {
    setEnabled(checked)
    localStorage.setItem('deliveryOn', checked ? 'true' : 'false')
  }

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const response = await _get_delivery_fee_stats()
        if (response?.data?.data) {
          setDeliveryFeeStats(response.data.data)
        }
      } catch (error) {
        console.error('Failed to fetch delivery fee stats:', error)
      }
    }
    fetchStats()
  }, [])

  const newAntIcon = (
    <LoadingOutlined style={{ fontSize: 24, color: '#008060' }} spin />
  )

  const openModal = (title, desc, lists) => {
    setModalContent({ title, desc, lists })
    setModalVisible(true)
  }

  const handleBikerListPageChange = (page, pageSize) => {
    setBikerListPage(page)
    setBikerListPageSize(pageSize)
  }

  const handleTodayDeliveryPageChange = (page, pageSize) => {
    setTodayDeliveryPage(page)
    setTodayDeliveryPageSize(pageSize)
  }

  const handlePreviousDeliveryPageChange = (page, pageSize) => {
    setPreviousDeliveryPage(page)
    setPreviousDeliveryPageSize(pageSize)
  }

  const trans_col = [
    { title: 'Pickup Time', dataIndex: 'pickup_time' },
    { title: 'Biker Name', dataIndex: 'biker_name' },
    {
      title: 'Order Code',
      dataIndex: 'order_code',
      render: text => (
        <span
          style={{ cursor: 'pointer' }}
          onClick={() => {
            openNotificationWithIcon(
              'info',
              'Order Details',
              `Viewing details for Order: ${text}`
            )
          }}
        >
          {text}
        </span>
      )
    },
    {
      title: 'Delivery Fee',
      dataIndex: 'delivery_fee',
      align: 'right',
      render: text => (
        <NumberFormat
          value={text}
          displayType={'text'}
          thousandSeparator={true}
          prefix={'₦'}
        />
      )
    },
    {
      title: 'Status',
      dataIndex: 'status',
      align: 'center',
      render: status => (
        <div style={{ textTransform: 'capitalize' }}>
          {' '}
          {status === 'success' ? (
            <Tag color='#87d068'>{status}</Tag>
          ) : status === 'cancel' || status === 'canceled' ? (
            <Tag color='#cf1322'>{status}</Tag>
          ) : (
            <Tag color='#ffa500'>{status}</Tag>
          )}
        </div>
      )
    }
  ]

  const tabItems = [
    {
      key: '1',
      label: 'Biker List',
      children: (
        <div>
          {bikerList.length === 0 && !spinnerLoading ? (
            <div style={{ textAlign: 'center', padding: '20px' }}>
              No Bikers Found.
            </div>
          ) : (
            <>
              <div style={{ marginTop: '2%' }}></div>
              <div className='mobile topup-data'>
                <Collapse defaultActiveKey={bikerList.length > 0 ? [bikerList[0].id] : []}>
                  {bikerList &&
                    bikerList?.length > 0 &&
                    bikerList.map(biker => (
                      <Collapse.Panel
                        showArrow={false}
                        key={biker.id}
                        header={
                          <p style={{ display: 'inline' }}>
                            Biker:{' '}
                            <strong>
                              {biker.firstName} {biker.lastName}
                            </strong>
                          </p>
                        }
                      >
                        <div>
                          <ul className='mobile-list-flex'>
                            <li>
                              <span>Date:</span>
                              <span>{biker.createdAt}</span>
                            </li>
                            <li>
                              <span>Name:</span>
                              <span>
                                {biker.firstName} {biker.lastName}
                              </span>
                            </li>
                            <li>
                              <span>Telephone:</span>
                              <span>
                                {biker.phoneCode}
                                {biker.phoneNumber}
                              </span>
                            </li>
                            <li>
                              <span>Orders Completed:</span>
                              <span>{biker.completedDeliveries}</span>
                            </li>
                          </ul>
                        </div>
                      </Collapse.Panel>
                    ))}
                </Collapse>
                <div style={{ marginTop: '2%' }}></div>
                <Pagination
                  showSizeChanger
                  current={bikerListPage}
                  total={totalBikers}
                  showTotal={(total, range) =>
                    `${range[0]} - ${range[1]} of ${total} bikers`
                  }
                  defaultPageSize={bikerListPageSize}
                  onChange={handleBikerListPageChange}
                />
              </div>
            </>
          )}
        </div>
      )
    },
    {
      key: '2',
      label: "Today's Delivery",
      children: (
        <div>
          {todayDeliveries.length === 0 && !spinnerLoading ? (
            <div style={{ textAlign: 'center', padding: '20px' }}>
              No Today's Deliveries Found.
            </div>
          ) : (
            <>
              <div className='mobile topup-data'>
                <Collapse defaultActiveKey={todayDeliveries.length > 0 ? [todayDeliveries[0].id] : []}>
                  {todayDeliveries.map(delivery => (
                    <Collapse.Panel
                      showArrow={false}
                      key={delivery.id}
                      header={
                        <span>
                          Order <strong>{delivery.orderCode}</strong> -{' '}
                          {new Date(delivery.createdAt).toLocaleDateString()} -
                          <span
                            style={{
                              textTransform: 'capitalize',
                              color:
                                delivery.status === 'success'
                                  ? '#87d068'
                                  : delivery.status === 'cancel' ||
                                    delivery.status === 'canceled'
                                    ? '#cf1322'
                                    : '#ffa500',
                              fontWeight: 'bold'
                            }}
                          >
                            {delivery.status}
                          </span>
                        </span>
                      }
                    >
                      <div>
                        <ul className='mobile-list-flex'>
                          <li>
                            <span>Pickup Time:</span>
                            <span>{delivery.pickup_time}</span>
                          </li>
                          <li>
                            <span>Biker Name:</span>
                            <span>
                              {delivery.biker?.user?.firstName}{' '}
                              {delivery.biker?.user?.lastName}
                            </span>
                          </li>
                          <li>
                            <span>Order Code:</span>
                            <span>{delivery.orderCode}</span>
                          </li>
                          <li>
                            <span>Customer:</span>
                            <span>
                              {delivery.user?.firstName}{' '}
                              {delivery.user?.lastName}
                            </span>
                          </li>
                          <li>
                            <span>Total Amount:</span>
                            <span>
                              <NumberFormat
                                value={delivery.totalAmount}
                                displayType={'text'}
                                thousandSeparator={true}
                                prefix={'₦'}
                              />
                            </span>
                          </li>
                          <li>
                            <span>Delivery Fee:</span>
                            <span>
                              <NumberFormat
                                value={parseFloat(delivery.delivery?.deliveryFee).toFixed(2)}
                                displayType={'text'}
                                thousandSeparator={true}
                                prefix={'₦'}
                              />
                            </span>
                          </li>
                          {delivery.delivery?.distance && (
                            <li>
                              <span>Distance:</span>
                              <span>{delivery.delivery.distance} km</span>
                            </li>
                          )}
                          <li>
                            <span>Status:</span>
                            <span>
                              <div style={{ textTransform: 'capitalize' }}>
                                {delivery.status === 'success' ? (
                                  <Tag color='#87d068'>{delivery.status}</Tag>
                                ) : delivery.status === 'cancel' ||
                                  delivery.status === 'canceled' ? (
                                  <Tag color='#cf1322'>{delivery.status}</Tag>
                                ) : (
                                  <Tag color='#ffa500'>{delivery.status}</Tag>
                                )}
                              </div>
                            </span>
                          </li>
                          {delivery.user?.address && (
                            <li>
                              <span>Track:</span>
                              <span>
                                <Button
                                  type="link"
                                  onClick={() => {
                                    const address = encodeURIComponent(delivery.user.address);
                                    window.open(`https://www.google.com/maps/search/?api=1&query=${address}`, "_blank");
                                  }}
                                  style={{ padding: 0, height: 'auto' }}
                                >
                                  Open in Google Maps
                                </Button>
                              </span>
                            </li>
                          )}
                        </ul>
                        {delivery.orderItems && delivery.orderItems.length > 0 && (
                          <div style={{ marginTop: '10px' }}>
                            <h4>Order Items:</h4>
                            <ul style={{ listStyle: 'none', padding: 0 }}>
                              {delivery.orderItems.map((item, index) => (
                                <li
                                  key={index}
                                  style={{
                                    marginBottom: '10px',
                                    display: 'flex',
                                    alignItems: 'center'
                                  }}
                                >
                                  {item.menuItem?.imageUrl && (
                                    <img
                                      src={item.menuItem.imageUrl}
                                      alt={item.menuItem.name}
                                      style={{
                                        width: '50px',
                                        height: '50px',
                                        marginRight: '10px',
                                        borderRadius: '5px'
                                      }}
                                    />
                                  )}
                                  <div>
                                    <strong>{item.menuItem?.name}</strong> -
                                    Qty: {item.quantity} - ₦
                                    <NumberFormat
                                      value={item.price}
                                      displayType={'text'}
                                      thousandSeparator={true}
                                    />
                                  </div>
                                </li>
                              ))}
                            </ul>
                          </div>
                        )}
                      </div>
                    </Collapse.Panel>
                  ))}
                </Collapse>
                <div style={{ marginTop: '2%' }}></div>
                <Pagination
                  showSizeChanger
                  current={todayDeliveryPage}
                  total={totalTodayDeliveries}
                  showTotal={(total, range) =>
                    `${range[0]} - ${range[1]} of ${total} deliveries`
                  }
                  defaultPageSize={todayDeliveryPageSize}
                  onChange={handleTodayDeliveryPageChange}
                />
              </div>
            </>
          )}
        </div>
      )
    },
    {
      key: '3',
      label: 'Previous Delivery',
      children: (
        <div>
          {previousDeliveries.length === 0 && !spinnerLoading ? (
            <div style={{ textAlign: 'center', padding: '20px' }}>
              No Previous Deliveries Found.
            </div>
          ) : (
            <>
              <div className='desktop show-all'>
                <Table
                  pagination={false}
                  bordered
                  columns={trans_col}
                  dataSource={previousDeliveries}
                  loading={spinnerLoading}
                />
              </div>
              <div className='mobile topup-data'>
                <Collapse defaultActiveKey={previousDeliveries.length > 0 ? [previousDeliveries[0].id] : []}>
                  {previousDeliveries.map(delivery => (
                    <Collapse.Panel
                      showArrow={false}
                      key={delivery.id}
                      header={
                        <span>
                          Order <strong>{delivery.orderCode}</strong> -{' '}
                          {new Date(delivery.createdAt).toLocaleDateString()} -
                          <span
                            style={{
                              textTransform: 'capitalize',
                              color:
                                delivery.status === 'success'
                                  ? '#87d068'
                                  : delivery.status === 'cancel' ||
                                    delivery.status === 'canceled'
                                    ? '#cf1322'
                                    : '#ffa500',
                              fontWeight: 'bold'
                            }}
                          >
                            {delivery.status}
                          </span>
                        </span>
                      }
                    >
                      <div>
                        <ul className='mobile-list-flex'>
                          <li>
                            <span>Pickup Time:</span>
                            <span>{delivery.pickup_time}</span>
                          </li>
                          <li>
                            <span>Biker Name:</span>
                            <span>
                              {delivery.biker?.user?.firstName}{' '}
                              {delivery.biker?.user?.lastName}
                            </span>
                          </li>
                          <li>
                            <span>Order Code:</span>
                            <span>{delivery.orderCode}</span>
                          </li>
                          <li>
                            <span>Customer:</span>
                            <span>
                              {delivery.user?.firstName}{' '}
                              {delivery.user?.lastName}
                            </span>
                          </li>
                          <li>
                            <span>Total Amount:</span>
                            <span>
                              <NumberFormat
                                value={delivery.totalAmount}
                                displayType={'text'}
                                thousandSeparator={true}
                                prefix={'₦'}
                              />
                            </span>
                          </li>
                          <li>
                            <span>Delivery Fee:</span>
                            <span>
                              <NumberFormat
                                thousandSeparator={true}
                                displayType={'text'}
                                value={parseFloat(delivery.delivery?.deliveryFee).toFixed(2)}

                                prefix={'₦'}
                              />
                            </span>
                          </li>
                          {delivery.delivery?.distance && (
                            <li>
                              <span>Distance:</span>
                              <span>{delivery.delivery.distance} km</span>
                            </li>
                          )}
                          <li>
                            <span>Status:</span>
                            <span>
                              <div style={{ textTransform: 'capitalize' }}>
                                {delivery.status === 'success' ? (
                                  <Tag color='#87d068'>{delivery.status}</Tag>
                                ) : delivery.status === 'cancel' ||
                                  delivery.status === 'canceled' ? (
                                  <Tag color='#cf1322'>{delivery.status}</Tag>
                                ) : (
                                  <Tag color='#ffa500'>{delivery.status}</Tag>
                                )}
                              </div>
                            </span>
                          </li>
                          {delivery.user?.address && (
                            <li>
                              <span>Track:</span>
                              <span>
                                <Button
                                  type="link"
                                  onClick={() => {
                                    const address = encodeURIComponent(delivery.user.address);
                                    window.open(`https://www.google.com/maps/search/?api=1&query=${address}`, "_blank");
                                  }}
                                  style={{ padding: 0, height: 'auto' }}
                                >
                                  Open in Google Maps
                                </Button>
                              </span>
                            </li>
                          )}
                        </ul>
                        {delivery.orderItems && delivery.orderItems.length > 0 && (
                          <div style={{ marginTop: '10px' }}>
                            <h4>Order Items:</h4>
                            <ul style={{ listStyle: 'none', padding: 0 }}>
                              {delivery.orderItems.map((item, index) => (
                                <li
                                  key={index}
                                  style={{
                                    marginBottom: '10px',
                                    display: 'flex',
                                    alignItems: 'center'
                                  }}
                                >
                                  {item.menuItem?.imageUrl && (
                                    <img
                                      src={item.menuItem.imageUrl}
                                      alt={item.menuItem.name}
                                      style={{
                                        width: '50px',
                                        height: '50px',
                                        marginRight: '10px',
                                        borderRadius: '5px'
                                      }}
                                    />
                                  )}
                                  <div>
                                    <strong>{item.menuItem?.name}</strong> -
                                    Qty: {item.quantity} - ₦
                                    <NumberFormat
                                      value={item.price}
                                      displayType={'text'}
                                      thousandSeparator={true}
                                    />
                                  </div>
                                </li>
                              ))}
                            </ul>
                          </div>
                        )}
                      </div>
                    </Collapse.Panel>
                  ))}
                </Collapse>
                <div style={{ marginTop: '2%' }}></div>
                <Pagination
                  showSizeChanger
                  current={previousDeliveryPage}
                  total={totalPreviousDeliveries}
                  showTotal={(total, range) =>
                    `${range[0]} - ${range[1]} of ${total} deliveries`
                  }
                  defaultPageSize={previousDeliveryPageSize}
                  onChange={handlePreviousDeliveryPageChange}
                />
              </div>
            </>
          )}
        </div>
      )
    }
  ]

  return (
    <div className='userprofile'>
      <Spin spinning={spinnerLoading} indicator={newAntIcon}>
        <div className='profile-content'>
          {/* <Navbar /> */}
          <div className='gray_bg_profile'>
            <div className='profile_to_left'>
              <div className=''>
                <div className='profile_nav'>{/* <RestaurantSideNav /> */}</div>
              </div>
            </div>
            <div className='profile_to_right'>
              <div className='contain'>
                <div className='main_container'>
                  {/* <MobileDashTabs /> */}
                  <div className='main_container_title_div mb-5'>
                    <div className='flex items-center flex-wrap p-6 justify-between   '>
                      <h5 className='mt-0'>My Delivery</h5>
                    </div>
                    <Divider style={{ margin: '0px 0 5px' }} />
                  </div>

                  <div className='main_container_inner_div'>
                    <div className='profile_container'>
                      <div className='slider_div_to_top'>
                        <Slider {...settings}>
                          <div
                            key={1}
                            className='item grid-4-box colored color_5 loyalty_card'
                          >
                            <div className='slick-div'>
                              <div className='slick-box'>
                                <div className='icon-box'>
                                  <img src={TablerCash} alt='tabler cash' />
                                </div>
                                <div className='slider-main-content'>
                                  <p>Today's Delivery</p>
                                  <h2>
                                    ₦
                                    <NumberFormat
                                      thousandSeparator={true}
                                      displayType={'text'}
                                      value={deliveryFeeStats.deliveryFeeToday || 0}
                                    />
                                  </h2>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            key={2}
                            className='item grid-4-box colored color_1 loyalty_card'
                          >
                            <div className='slick-div'>
                              <div className='slick-box'>
                                <div className='icon-box'>
                                  <img src={TablerCash} alt='tabler cash' />
                                </div>
                                <div className='slider-main-content'>
                                  <p>This Month's Delivery</p>
                                  <h2>
                                    ₦
                                    <NumberFormat
                                      thousandSeparator={true}
                                      displayType={'text'}
                                      value={deliveryFeeStats.deliveryFeeThisMonth || 0}
                                    />
                                  </h2>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            key={3}
                            className='item grid-4-box colored color_1 loyalty_card'
                          >
                            <div className='slick-div'>
                              <div className='slick-box'>
                                <div className='icon-box'>
                                  <img src={TablerCash} alt='tabler cash' />
                                </div>
                                <div className='slider-main-content'>
                                  <p>Till Date Delivery</p>
                                  <h2>
                                    ₦
                                    <NumberFormat
                                      thousandSeparator={true}
                                      displayType={'text'}
                                      value={deliveryFeeStats.deliveryFeeTillDate || 0}
                                    />
                                  </h2>
                                </div>
                              </div>
                            </div>
                          </div>
                        </Slider>
                      </div>
                      <div className=''>
                        <button
                          onClick={() => setIsAddBikerModalVisible(true)}
                          className='bg_side_green'
                        >
                          Add New Biker
                        </button>
                      </div>
                    </div>
                  </div>
                  <Tabs defaultActiveKey='1' items={tabItems} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Spin>
      <FooterDisplay />
      <AddBikerModal
        isModalVisible={isAddBikerModalVisible}
        onCancel={() => setIsAddBikerModalVisible(false)}
        restaurantId={profileData?.restaurantId}
        onBikerAdded={fetchBikerListData}
      />
      <OrderAcceptanceModal
        isVisible={isOrderAcceptanceModalVisible}
        onClose={() => setIsOrderAcceptanceModalVisible(false)}
        order={selectedOrder}
        onOrderUpdate={(orderId, status) => {
          console.log(`Order ${orderId} status updated to ${status}`)
        }}
        restaurantId={restaurantUserId}
      />
    </div>
  )
}

export default RestaurantDelivery
